export default "__VITE_ASSET__03ef4807__"